import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 27504 18278"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:398.614}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970270362080">
        <path
          d="M4395 924C2847-625 199 471 199 2662v12955c0 2189 2648 3286 4196 1738l6832-6832c763-763 763-2003 0-2767L4395 924zM19901 924c-1548-1549-4196-453-4196 1738v12955c0 2189 2648 3286 4196 1738l6831-6832c764-763 764-2003 0-2767L19901 924z"
          className="fill stroke1"
          style={{
            strokeWidth: 398.614,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
